import React from 'react';
import { renderDate, renderMoney, dateRangeFilter } from '../../../common/services/util';
import DateRangeFilter from 'common/components/DateRangeFilter';

export const columnsPublicStock = [
    {
        title: 'Referencia',
        field: 'reference',
        defaultSort: 'desc',
        render: row => <span className="ref-chip">{row.reference}</span>,
        cellStyle: { whiteSpace: 'nowrap' }
    },
    { title: 'Descripcion', field: 'description', cellStyle: { width: '600px' } },
    { title: 'Marca', field: 'brand' },
    { title: 'Modelo', field: 'model', cellStyle: { width: '300px'} },
    { title: 'NºSerie', field: 'number', cellStyle: { width: '500px'} }, 
    { title: 'Color', field: 'color'},
    { title: 'Cantidad', field: 'count', type: 'numeric' },
    { title: 'Calidad', field: 'quality' },
    { title: 'Ult. Modificacion', field: 'lastUpdated', type: 'date', editable: 'never',
        filterComponent: props => <DateRangeFilter {...props} />,
        customFilterAndSearch: (filter, rowData) => dateRangeFilter(filter, rowData.lastUpdated),
        render: rowData => rowData ? renderDate(rowData.lastUpdated) : ""
    },
    { title: 'PVM', field: 'pvm', type: 'numeric',
        render: rowData => renderMoney(rowData ? rowData.pvm : "")
    },
    { title: 'OBS', field: 'obs', cellStyle: { width: '300px' } }
]